import React, { useState, useEffect } from 'react';
import { Form, Input, Select, InputNumber, Button, Card, message, Table, Modal, Space, Tag } from 'antd';
import { Badge } from 'react-bootstrap';
import Icon, {
    SearchOutlined,
    PlusOutlined,
    DollarOutlined,
    UserOutlined,
    SwapOutlined,
    CalendarOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import '../../assets/styles/dashboard.css';
import AddExpensesModel from './Components/AddExpensesModel';
import EditExpensesModel from './Components/EditExpensesModel';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import { auto } from '@popperjs/core';
import EditIncomModel from './Components/EditIncomModel';
import ConfirmationModal from '../Components/ConfirmationModal';
import deleteBalanceSheet from '../../Uitiles/DelectBalanceSeet';
import { debugInfo, debugLog } from '../../utils/debug';
import ExpensesName from './SubCompontes/ExpensesName';
import AddByName from './SubCompontes/AddByName';
import Paginationnew from '../../Uitiles/Paginationnew';
const { Option } = Select;
const { TextArea } = Input;

// Add custom styles for hiding scrollbar
const hideScrollbarStyle = {
    maxHeight: '80vh',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
};

const ExpensesManagement = () => {
    const [form] = Form.useForm();
    const [transactionType, setTransactionType] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editIncome, setEditIncome] = useState(false);
    const [editIncomeModel, setEditIncomeModel] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [incomeType, setIncomeType] = useState('');
    const [mockData, setMockData] = useState([]);
    const [expenseType, setExpenseType] = useState('');
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);

    useEffect(() => {

        fetchIncome();
    }, []);


    const fetchIncome = async () => {
        const tableSchema = "";
        const tableName = "expenses";
        const conditions = {

        };
        const orderBy = 'id DESC';
        const search = {
            amount: searchText,
            add_by: searchText,
            date: searchText,
            description: searchText,
            expenseType: searchText,

        };
        const pagination = {};
        const margedata = [
            {
                "target_table": "users",
                "target_column": "id",
                "target_value": "add_by",
                "target_label": "user_details"
            }
        ];
        const income = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('income', income);
        if (income.success === true) {
            setMockData(income.data);
            setTotal(income.totalPages);
            // Set expenseType based on the first record if available
            if (income.data && income.data.length > 0) {
                setExpenseType(income.data[0].expenseType || '');
            }
        }
    };

    const handlePageChange = (page) => {
        setPage(page);
        fetchIncome();
    };


    const capitalizeWords = (str) => {
        if (!str) return '';
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (id) => <span> {id}</span>
        },
        {
            title: 'Added By',
            dataIndex: 'user_details',
            key: 'user',
            render: (_, record) => (
                <AddByName id={record.id} record={record} />
            )
        },
        {
            title: 'Type/Provider/Service',
            dataIndex: "title",
            key: "title",
            render: (_, record) => (
                <ExpensesName id={record.id} record={record} />
            )
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount) => (
                <span>₹{Number(amount).toFixed(2)}</span>
            )
        },
        {
            title: 'Transfer Type',
            dataIndex: 'transactionType',
            key: 'transactionType',
            render: (transactionType) => <span><SwapOutlined /> {transactionType}</span>
        },
        {
            title: 'Expense Type',
            dataIndex: 'category',
            key: 'category',
            render: (category) => <span><SwapOutlined /> {capitalizeWords(category)}</span>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => <span><Tag color={status === 'active' ? 'green' : 'red'}>{status}</Tag></span>
        },
        {
            title: 'Date',
            key: 'date',
            render: (row) => {
                const dateValue = row.date || row.created_at;
                if (!dateValue) return '-';
                const dateObj = new Date(dateValue);
                const formattedDate = dateObj.toLocaleDateString('en-IN', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });
                return <span><CalendarOutlined /> {formattedDate}</span>;
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button className="dc-update-servicesss" onClick={() => handleEdit(record)} style={{ minWidth: '100px' }}>
                        <EditOutlined /> Edit
                    </Button>
                    <Button className="dc-update-servicesss btn-danger" onClick={() => handleDelete(record)} style={{ minWidth: '100px' }}>
                        <DeleteOutlined /> Delete
                    </Button>
                </Space>
            ),
        },
    ];

    const handleEdit = (record) => {
        // Implement edit functionality
        debugLog('Edit record:', record);
        setEditIncome(record);
        setEditIncomeModel(true);

    };

    const handleDelete = (record) => {
        setSelectedRecord(record);
        setIsDeleteModalVisible(true);
    };

    const handleConfirmDelete = async () => {
        if (!selectedRecord) return;

        const tableSchema = '';
        const tableName = 'expenses';
        const conditions = { id: selectedRecord.id };

        try {
            const expenses = await oneKlicks.delete(tableSchema, tableName, conditions);
            debugLog('expenses', expenses);
            if (expenses.success === true) {
                const deleteBalance = await deleteBalanceSheet(selectedRecord.transaction_id);
                debugLog('deleteBalance', deleteBalance);
                message.success('Income deleted successfully');

            } else {
                message.error('Failed to delete income.');
            }
        } catch (error) {
            debugLog('Delete error:', error);
            message.error('Something went wrong while deleting.');
        } finally {
            setIsDeleteModalVisible(false);
            setSelectedRecord(null);
            fetchIncome();
        }
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
        setTransactionType(''); // Reset transaction type state
    };

    const handleUpdate = () => {
        fetchIncome();
        setEditIncomeModel(false);
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">

            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Expenses Management</h5>
                                <Badge bg="info">Expenses</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <div className="filters-wrapper">
                                    <Input
                                        placeholder="Search income records"
                                        className='h-40'
                                        prefix={<SearchOutlined />}
                                        style={{ width: 300 }}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>

                                <div className="d-flex justify-content-between align-items-center" style={{ gap: '10px' }}>
                                    <Button className="dc-btn dc-update-servicesss" data-id="4174" data-post="18128" onClick={showModal}>
                                        <PlusOutlined /> Add New Expenses
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Added By</th>
                                        <th>Type/Provider/Service</th>
                                        <th>Amount</th>
                                        <th>Transfer Type</th>
                                        <th>Expense Type</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mockData.map((item) => (
                                        <tr key={item.id}>
                                            <td data-label="ID">{item.id}</td>
                                            <td data-label="Added By">{item.user_details.id}</td>
                                            <td data-label="Type/Provider/Service">{item.title}</td>
                                            <td data-label="Amount">₹{Number(item.amount).toFixed(2)}</td>
                                            <td data-label="Transfer Type">{item.transactionType}</td>
                                            <td data-label="Expense Type">{item.category}</td>
                                            <td data-label="Status"><Tag color={item.status === 'active' ? 'green' : 'red'}>{item.status}</Tag></td>
                                            <td data-label="Date">{item.date}</td>
                                            <td data-label="Actions">
                                                <div className="d-flex justify-content-end" style={{ gap: 10, flexDirection: 'row' }}>
                                                    <Button className="dc-update-servicesss fit-content" onClick={() => handleEdit(item)} style={{ minWidth: '100px' }}><EditOutlined /> View</Button>
                                                    <Button className="dc-update-servicesss" onClick={() => handleEdit(item)} style={{ minWidth: '100px' }}>
                                                        <EditOutlined /> Edit
                                                    </Button>
                                                    <Button className="dc-update-servicesss btn-danger" onClick={() => handleDelete(item)} style={{ minWidth: '100px' }}>
                                                        <DeleteOutlined /> Delete
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <Paginationnew currentPage={page} totalPages={total} handlePageChange={handlePageChange} />
                    </div>
                </div>
            </div>

            {/* Bootstrap-style Modal for Add Income */}
            {isModalVisible && (
                <AddExpensesModel isOpen={isModalVisible} toggle={() => setIsModalVisible(!isModalVisible)} getIncome={fetchIncome} />
            )}
            {editIncomeModel && (
                <EditExpensesModel isOpen={editIncomeModel} toggle={() => setEditIncomeModel(!editIncomeModel)} getIncome={editIncome} fetchIncome={handleUpdate} />
            )}
            {/* Add the ConfirmationModal */}
            <ConfirmationModal
                isOpen={isDeleteModalVisible}
                onClose={() => {
                    setIsDeleteModalVisible(false);
                    setSelectedRecord(null);
                }}
                onConfirm={handleConfirmDelete}
                title="Delete Income"
                content={`Are you sure you want to delete income with ID: ${selectedRecord?.id}?`}
            />
        </div>
        // {/* <section className="dc-haslayout dc-dbsectionspace">
        //     <div className="">
        //         <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        //             <Card className="shadow-sm" style={{ width: '100%' }}>
        //                 <div className="d-flex justify-content-between align-items-center mb-4">
        //                     <Input
        //                         placeholder="Search income records"
        //                         prefix={<SearchOutlined />}
        //                         style={{ width: 300 }}
        //                         onChange={(e) => setSearchText(e.target.value)}
        //                     />
        //                     <a className="dc-btn dc-update-servicesss" data-id="4174" data-post="18128" onClick={showModal}>
        //                         <PlusOutlined /> Add New Expenses
        //                     </a>
        //                 </div>
        //                 <div style={{ width: '100%', overflowX: 'auto' }}>
        //                     <Table
        //                         columns={columns}
        //                         dataSource={mockData}
        //                         rowKey="id"
        //                         pagination={{ pageSize: 10 }}
        //                         style={{ width: '100%' }}
        //                     />
        //                 </div>
        //             </Card>
        //         </div>
        //     </div>

        //     {/* Bootstrap-style Modal for Add Income */}
        //     {isModalVisible && (
        //         <AddExpensesModel isOpen={isModalVisible} toggle={() => setIsModalVisible(!isModalVisible)} getIncome={fetchIncome} />
        //     )}
        //     {editIncomeModel && (
        //         <EditExpensesModel isOpen={editIncomeModel} toggle={() => setEditIncomeModel(!editIncomeModel)} getIncome={editIncome} fetchIncome={handleUpdate}/>
        //     )}
        //     {/* Add the ConfirmationModal */}
        //     <ConfirmationModal
        //         isOpen={isDeleteModalVisible}
        //         onClose={() => {
        //             setIsDeleteModalVisible(false);
        //             setSelectedRecord(null);
        //         }}
        //         onConfirm={handleConfirmDelete}
        //         title="Delete Income"
        //         content={`Are you sure you want to delete income with ID: ${selectedRecord?.id}?`}
        //     />
        // </section> */}
    );


};

export default ExpensesManagement; 
